// packages/warning/src/index.ts
import { logged } from "./utils.mjs";
function isDev() {
  return globalThis.SCRIPT_DEBUG === true;
}
function warning(message) {
  if (!isDev()) {
    return;
  }
  if (logged.has(message)) {
    return;
  }
  console.warn(message);
  try {
    throw Error(message);
  } catch {
  }
  logged.add(message);
}
export {
  warning as default
};
//# sourceMappingURL=index.mjs.map
